import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "b446e3f7-2e36-4746-bb1b-b71fcd380bce",
  publicId: "2",
  name: "Impulse Responses",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },

  body: [principle01, principle02, task01, task02],
};

export default lesson;
